import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { LabelQueueProvider } from './contexts/LabelQueueContext';
import { ToastProvider } from './components/ui/Toast';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { Inventory } from './pages/Inventory';
import { ToolDetail } from './pages/ToolDetail';
import { Scan } from './pages/Scan';
import { Checkout } from './pages/Checkout';
import { Jobs } from './pages/Jobs';
import { JobDetail } from './pages/JobDetail';
import { Reports } from './pages/Reports';
import { CostAnalysis } from './pages/CostAnalysis';
import { Preferences } from './pages/Preferences';
import { Labels } from './pages/Labels';
import { Audit } from './pages/Audit';
import { Users } from './pages/admin/Users';
import { Categories } from './pages/admin/Categories';
import { Locations } from './pages/admin/Locations';
import { DiscardReasons } from './pages/admin/DiscardReasons';
import { Import } from './pages/admin/Import';
import { Backup } from './pages/admin/Backup';
import { Settings } from './pages/admin/Settings';
import { ProtectedRoute } from './components/ProtectedRoute';

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <LabelQueueProvider>
          <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register/:token" element={<Register />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="inventory/:id" element={<ToolDetail />} />
          <Route path="scan" element={<Scan />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="jobs/:id" element={<JobDetail />} />
          <Route path="reports" element={<Reports />} />
          <Route path="cost-analysis" element={<CostAnalysis />} />
          <Route path="preferences" element={<Preferences />} />
          <Route path="labels" element={<Labels />} />
          <Route path="audit" element={<Audit />} />

          {/* Admin routes */}
          <Route path="admin/users" element={<Users />} />
          <Route path="admin/categories" element={<Categories />} />
          <Route path="admin/locations" element={<Locations />} />
          <Route path="admin/discard-reasons" element={<DiscardReasons />} />
          <Route path="admin/import" element={<Import />} />
          <Route path="admin/backup" element={<Backup />} />
          <Route path="admin/settings" element={<Settings />} />
        </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </LabelQueueProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
